/* eslint-disable no-await-in-loop */

'use-strict';

import { IScope } from 'angular';
import { FileInput } from 'src/app/@types';
import LogService from 'src/app/shared/services/log';
import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { ConfigService } from '../../../shared/config/config.service';
import { NumberConversionService } from '../../../shared/converter/number-converter.service';
import { FileService } from '../../../shared/storage/file.service';
import { DeepPartial } from '../../../src/app/@shared-types';
import { EFileSection, FileUploadRequest } from '../../../src/app/@shared-types/misc/file';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

interface FileUploadFormScope extends IScope {
  show: boolean,
  section: string,
  identifier: string,
  sending: boolean,
  filetypes: string[],
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  formTransmission: () => void,
  filesToUpload: FileInput[],
  newVehicleData: {
    invoiceDate: string,
    rrpInvoice: string,
  }
}

/* @ngInject */
export default function UploadFileController(
  $scope: FileUploadFormScope,
  fileService: FileService,
  salesApiService: SalesAPIService,
  numberConversionService: NumberConversionService,
  configService: ConfigService,
  logService: LogService,
  toastService: ToastService,
): void {
  $scope.sending = false;
  $scope.filetypes = configService.get('general_filetypes') || [];

  $scope.exitForm = () => $scope.exit({ removeLock: true });

  $scope.formTransmission = async () => {
    $scope.sending = true;
    const uploadPromises: Promise<any>[] = [];

    for (const fileWrapper of $scope.filesToUpload) {
      const { file } = fileWrapper;

      const fileRequest: FileUploadRequest = {
        extension: '',
        identifier: $scope.identifier,
        section: $scope.section as EFileSection,
        type: file.fileType,
      };

      await fileService.uploadContextualFile(
        file.file,
        file.progressBar,
        fileRequest,
      );
    }

    await Promise.all(uploadPromises)
      .then(async () => {
        // If any file is an invoice update the car with date and price
        if ($scope.filesToUpload.filter((f) => f.file.fileType === 'Eingangsrechnung').length) {
          const changedVals: DeepPartial<AutoboardVehicle> = {
            _id: $scope.identifier,
            vehicleData: {
              costs: {
                invoiceDate: numberConversionService
                  .frontendStringToDate($scope.newVehicleData.invoiceDate),
              },
              price: {
                retailPrices: {
                  invoice: numberConversionService
                    .parseStringFloat($scope.newVehicleData.rrpInvoice),
                },
              },
            },
          };

          await salesApiService.putVehicle(changedVals);
        }

        return $scope.exit({ removeLock: true });
      })
      .catch((e) => {
        toastService.toast(ToastType.ERROR, 'Fehler beim Hochladen der Dokumente');
        logService.error(e);
        $scope.exit({ removeLock: true });
      });
  };

  $scope.filesToUpload = [{
    extension: '',
    file: '',
    fileType: '',
    progressBar: '',
  }];
  $scope.newVehicleData = {
    invoiceDate: '',
    rrpInvoice: '',
  };
}
